import {Search2Icon} from "@chakra-ui/icons";
import {
  Box, Button, Center,
  Checkbox,
  HStack,
  Input, Select,
  Spinner,
  Table,
  TableContainer,
  Tbody,
  Th,
  Thead,
  Tr
} from '@chakra-ui/react'
import React, {useState} from "react";
import {useQuery} from "react-query";
import {useParams} from "react-router-dom";

import {getCandidates} from "../../shared/Api";
import {adminKeys} from "../../shared/QueryKeys";
import {extractData, toIsoString} from "../../shared/Utils";
import EDICandidateSummaryItem from "./EDICandidateSummaryItem";

const EDICandidatesList = () => {
  const params = useParams<{
    group: string;
  }>();

  const group = params.group || "";

  const today: string = toIsoString(new Date()).slice(0, 10);

  const urlParams = new URLSearchParams(window.location.search);
  // from .../*group*?mock=only / all
  const mockParam = urlParams.get('mock');
  const mockCandidates = mockParam === 'all' || mockParam === 'only' ? mockParam : 'exclude';

  const minDate: string = "2022-12-01";
  const startDate: string = "2024-03-01";

  const [idValue, setIdValue] = useState<string>("");
  const [nameValue, setNameValue] = useState<string>("");
  const [startDateValue, setStartDateValue] = useState<string>(startDate);
  const [endDateValue, setEndDateValue] = useState<string>(today);
  const [includeInvited, setIncludeInvited] = useState<boolean>(true);
  const [includeInProgress, setIncludeInProgress] = useState<boolean>(true);
  const [includeCompleted, setIncludeCompleted] = useState<boolean>(true);
  const [page, setPage] = useState<number>(0);
  const [pageSize, setPageSize] = useState<number>(25);

  function handleKeyPress (key: string) {
    if (key === 'Enter') {
      return candidatesQuery.refetch();
    }
  }
  const candidatesQuery = useQuery(adminKeys.candidatesSummary(), () =>
      getCandidates({
        startDateValue: startDateValue,
        endDateValue: endDateValue,
        includeCompleted: includeCompleted,
        includeInProgress: includeInProgress,
        includeInvited: includeInvited,
        region: "",
        institution: "",
        isTeacher: false,
        group: ("EDI"+group.trim()).toLowerCase(),
        institutionOnly: false,
        username:idValue.trim().toLowerCase(),
        name: nameValue.trim().toLowerCase(),
        testName: "",
        mockCandidates: mockCandidates
      }, true).then(extractData),
    {retry: true, refetchOnWindowFocus: false}
  );

  if (!candidatesQuery.data) {
    return (
      <Center height="200px">
        <Spinner />
      </Center>
    );
  } else {
    return (
      <Box width="95%" marginX="auto">
        <div>
          <HStack alignSelf="start" spacing={10} paddingY={1}>
            <Input type="date" id="startDate" value={startDateValue}
                   min={minDate} max={today}
                   onChange={(event) => {
                     setStartDateValue(event.target.value);
                   }}/>
            <Input type="date" id="endDate" value={endDateValue}
                   min={minDate} max={today}
                   onChange={(event) => {
                     setEndDateValue(event.target.value);
                   }}/>
            <Checkbox minW="fit-content"
                      onChange={(e) => {
                        setIncludeInvited(e.target.checked);
                      }}
                      defaultChecked={includeInvited}>
              Sin iniciar
            </Checkbox>
            <Checkbox minW="fit-content"
                      onChange={(e) => {
                        setIncludeInProgress(e.target.checked);
                      }}
                      defaultChecked={includeInProgress}>
              En proceso
            </Checkbox>
            <Checkbox minW="fit-content"
                      onChange={(e) => {
                        setIncludeCompleted(e.target.checked);
                      }}
                      defaultChecked={includeCompleted}>
              Completados
            </Checkbox>
          </HStack >
          <HStack alignSelf="start" spacing={10} paddingY={1}>
            <Input placeholder='Identificación'
                   onKeyDown={(event) => handleKeyPress(event.key)}
                   onChange={(event)=>setIdValue(event.target.value)}/>
            <Input placeholder='Nombre'
                   onKeyDown={(event) => handleKeyPress(event.key)}
                   onChange={(event)=>setNameValue(event.target.value)} />
          </HStack >
          <HStack alignSelf="start" spacing={10} paddingY={1}>
            <Select value={pageSize.toString()} isReadOnly={true} width="1xs"
                    onChange={(event)=> {setPageSize(parseInt(event.target.value)); }}>
              <option value={25}>25</option>
              <option value={50}>50</option>
              <option value={100}>100</option>
              <option value={250}>250</option>
              <option value={(candidatesQuery.data).length}>Todos</option>
            </Select>

            <Button leftIcon={<Search2Icon />} colorScheme="teal" onClick={()=> {
              setPage(0);
              return candidatesQuery.refetch();
            }}
                    disabled={candidatesQuery.isFetching}>
              Filtrar
            </Button>
            
            {candidatesQuery.isFetching &&
              <Spinner />
            }
          </HStack >
        </div>

        <TableContainer width="95vw">
          <Table size='sm' variant='striped' whiteSpace="normal">
            <Thead>
              <Tr>
                <Th>Identificación</Th>
                <Th>Nombre</Th>
                <Th>Institución</Th>
                <Th>Grupo</Th>
                <Th>Reading - estado</Th>
                <Th>Inicio</Th>
                <Th>Fin</Th>
                <Th>Última Pregunta</Th>
                <Th> </Th>
                <Th>Listening - estado</Th>
                <Th>Inicio</Th>
                <Th>Fin</Th>
                <Th>Última Pregunta</Th>
                <Th> </Th>
                <Th>Speaking - estado</Th>
                <Th>Inicio</Th>
                <Th>Fin</Th>
                <Th> </Th>
              </Tr>
            </Thead>

            <Tbody key="List">
              {candidatesQuery.isSuccess && candidatesQuery.data.length ? (
                (candidatesQuery.data).slice(page, page+pageSize).map((candidate) => (
                  <EDICandidateSummaryItem candidateSummary={candidate} />
                ))
              ) : (
                <Tr key={"empty"}>
                </Tr>
              )}

            </Tbody>
          </Table>
        </TableContainer>
        <HStack paddingY={10} justifyContent="end">
          <Button
            colorScheme="teal"
            disabled={page === 0}
            onClick={()=>setPage(page-pageSize)}
          >
            Anterior
          </Button>
          <Button
            colorScheme="teal"
            disabled={page+pageSize >= (candidatesQuery.data).length}
            onClick={()=>setPage(page+pageSize)}
          >
            Siguiente
          </Button>
        </HStack>
      </Box>
    );
  }
};

export default EDICandidatesList;
